import { render, staticRenderFns } from "./SortableFirmwideEnergyByFuel.vue?vue&type=template&id=b6d9510c"
import script from "./SortableFirmwideEnergyByFuel.vue?vue&type=script&lang=js"
export * from "./SortableFirmwideEnergyByFuel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports